"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectHighchartsOptionsProvider = void 0;
const ProjectDashboardHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectDashboardHighchartsOptionsProvider");
const LifecycleHighchartsCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/highcharts/LifecycleHighchartsCalculations");
const RetentionHighchartsCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionHighchartsCalculations");
const StickinessHighchartsCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/highcharts/StickinessHighchartsCalculations");
const RetentionChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionChartSettingsJSONModel");
const StickinessChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessChartSettingsJSONModel");
const AggregationJSONModel_1 = require("src/hello_assets/src/components/model/common/AggregationJSONModel");
const NewUsersHighchartsCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/state/data/highcharts/NewUsersHighchartsCalculations");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const lodash_1 = __importDefault(require("lodash"));
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const FunnelHighchartsCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/state/data/highcharts/FunnelHighchartsCalculations");
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const HighchartsThemeFacade_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsThemeFacade");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const getActiveUsersHighchartsOptionsDataSource = (state, aggregation) => {
    switch (aggregation) {
        case AggregationJSONModel_1.Aggregation.dau:
            return state === null || state === void 0 ? void 0 : state.dau;
        case AggregationJSONModel_1.Aggregation.wau:
            return state === null || state === void 0 ? void 0 : state.wau;
        case AggregationJSONModel_1.Aggregation.mau:
            return state === null || state === void 0 ? void 0 : state.mau;
    }
    return state === null || state === void 0 ? void 0 : state.dau;
};
const getActiveUsersChartTitle = (aggregation) => {
    switch (aggregation) {
        case AggregationJSONModel_1.Aggregation.dau:
            return "Daily Active Users";
        case AggregationJSONModel_1.Aggregation.wau:
            return "Weekly Active Users";
        case AggregationJSONModel_1.Aggregation.mau:
            return "Monthly Active Users";
    }
    return "Daily Active Users";
};
exports.ProjectHighchartsOptionsProvider = {
    getActiveUsersCSV: (data, parameters) => {
        if (data && parameters.aggregation) {
            const chartTitle = getActiveUsersChartTitle(parameters.aggregation);
            const activeUsersState = getActiveUsersHighchartsOptionsDataSource(data, parameters.aggregation);
            const intervalStartMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(activeUsersState.intervalStartTimeSec * 1000).startOf("day");
            return {
                title: chartTitle,
                data: lodash_1.default.map(activeUsersState.data, (currentValue, idx) => {
                    return {
                        activeUsers: currentValue,
                        timeMillis: intervalStartMoment.clone().add(idx, "day").valueOf()
                    };
                })
            };
        }
        return undefined;
    },
    getActiveUsersOptions: (data, parameters, chartStatus) => {
        if (data && parameters.aggregation) {
            const chartTitle = getActiveUsersChartTitle(parameters.aggregation);
            const activeUsersState = getActiveUsersHighchartsOptionsDataSource(data, parameters.aggregation);
            const result = ProjectDashboardHighchartsOptionsProvider_1.ProjectDashboardHighchartsOptionsProvider.optionsForChartLastNIntervalData(activeUsersState, { chartTitle: chartTitle }, chartStatus);
            if (result.options.exporting) {
                result.options.exporting.enabled = false;
            }
            return result;
        }
        return { options: {}, chartStatus: chartStatus };
    },
    getNewUsersCSV: (data, parameters) => {
        return NewUsersHighchartsCalculations_1.NewUsersHighchartsCalculations.getNewUsersCSV(data, parameters);
    },
    getNewUsersOptions: (data, parameters, chartStatus) => {
        return {
            options: NewUsersHighchartsCalculations_1.NewUsersHighchartsCalculations.optionsFor({
                data: data,
                lineType: parameters.lineType,
                cumulativeGrowthPercent: parameters.cumulativeGrowthPercent
            }),
            chartStatus: chartStatus
        };
    },
    getRetention: (stateData, parameters, chartStatus) => {
        if (stateData) {
            if (!!process.env.IS_TEST_SERVER) {
                console.log("getRetention:", { stateData, parameters, chartStatus });
            }
            const isOvertime = parameters.chartType === RetentionChartSettingsJSONModel_1.ChartType.overtime;
            const { options, chartStatus: chartStatusFromCalculations } = RetentionHighchartsCalculations_1.RetentionHighchartsCalculations.optionsFor({
                request: stateData.request,
                response: stateData.response,
                isOvertimeChart: isOvertime,
                filterPeriod: parameters.filterPeriod,
                filterCohortDays: parameters.filterCohortDays,
                shouldAddPeriod: parameters.shouldAddPeriod
            });
            if (options.exporting) {
                options.exporting.enabled = false;
            }
            return { options, chartStatus: chartStatusFromCalculations || chartStatus };
        }
        if ((chartStatus === null || chartStatus === void 0 ? void 0 : chartStatus.status) === "notLoaded") {
            const stubOptionsResult = RetentionHighchartsCalculations_1.RetentionHighchartsCalculations.stubOptions();
            return {
                options: stubOptionsResult.options,
                chartStatus: chartStatus,
            };
        }
        return { options: {}, chartStatus: chartStatus };
    },
    getFunnel: (funnel, parameters, chartStatus) => {
        if (process.env.NODE_ENV === "development") {
            console.log("ProjectHighchartsOptionsProvider.getFunnel:", { funnel, parameters, chartStatus: lodash_1.default.cloneDeep(chartStatus) });
        }
        if (funnel) {
            const options = FunnelHighchartsCalculations_1.FunnelHighchartsCalculations.optionsFor({
                request: funnel.request,
                response: funnel.response,
                chartType: parameters.chartType,
            });
            if (!!process.env.IS_TEST_SERVER) {
                console.log("ProjectHighchartsOptionsProvider.getFunnel: calculated options", lodash_1.default.cloneDeep(options));
            }
            if (lodash_1.default.isEmpty(options) && (chartStatus === null || chartStatus === void 0 ? void 0 : chartStatus.status) === "loaded") {
                chartStatus = {
                    status: "noData"
                };
            }
            if (options.exporting) {
                options.exporting.enabled = false;
            }
            if (process.env.NODE_ENV === "development") {
                console.log("ProjectHighchartsOptionsProvider.getFunnel: options", options);
            }
            return {
                options: options,
                chartStatus: chartStatus
            };
        }
        if ((chartStatus === null || chartStatus === void 0 ? void 0 : chartStatus.status) === "notLoaded") {
            const options = FunnelHighchartsCalculations_1.FunnelHighchartsCalculations.optionsFor({
                request: {
                    returnEvents: [
                        { newUser: null },
                        { event: { eventDescription: { name: "ViewMainScreen" } } },
                        { event: { eventDescription: { name: "ViewProfile" } } },
                        { event: { eventDescription: { name: "ViewPost" } } },
                    ],
                    lastNDays: 30
                },
                response: {
                    intervalStartTimeSec: DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay().startOf("day").subtract(29, "day").valueOf() / 1000,
                    classic: Uint32Array.from([13209, 9277, 5000, 2000]),
                    overtime: Array.from(lodash_1.default.range(4).map(() => HighchartsCalculationsCommonUtils_1.HighchartsRandomChartGenerator.random2(30)), v => Uint32Array.from(v)),
                },
                chartType: parameters.chartType,
            });
            lodash_1.default.each(options.series, (series, idx) => {
                if (idx === 1) {
                    series.color = "#d0d0d0";
                }
                else if (idx === 2) {
                    series.color = HighchartsThemeFacade_1.UsergeekHighchartsColors.black;
                }
            });
            return {
                options: options,
                chartStatus: chartStatus,
            };
        }
        return {
            options: {},
            chartStatus: chartStatus,
        };
    },
    getStickiness: (stateData, parameters, chartStatus) => {
        if (stateData) {
            const defaultStickinessChartSettingsJSONModelSerializedState = StickinessChartSettingsJSONModel_1.StickinessChartSettingsJSONModel.getDefaultModel();
            const options = StickinessHighchartsCalculations_1.StickinessHighchartsCalculations.optionsFor({
                request: stateData.request,
                response: stateData.response,
                lineType: parameters.lineType,
                chartType: parameters.chartType,
                filterCohortDays: parameters.filterCohortDays || defaultStickinessChartSettingsJSONModelSerializedState.filterCohortDays,
                filterFrequency: parameters.filterFrequency || defaultStickinessChartSettingsJSONModelSerializedState.filterFrequency,
                shouldAddPeriod: parameters.shouldAddPeriod
            });
            if (options.exporting) {
                options.exporting.enabled = false;
            }
            return { options, chartStatus: chartStatus };
        }
        if ((chartStatus === null || chartStatus === void 0 ? void 0 : chartStatus.status) === "notLoaded") {
            const defaultStickinessChartSettingsJSONModelSerializedState = StickinessChartSettingsJSONModel_1.StickinessChartSettingsJSONModel.getDefaultModel();
            const options = StickinessHighchartsCalculations_1.StickinessHighchartsCalculations.optionsFor({
                request: {
                    periodType: CommonTypesConversions_1.CommonTypesConversions.periodType.fromLastNDays(30),
                    lineType: LineTypeJSONModel_1.LineType.cumulative,
                    cohortQuery: [{ "session": null }],
                    returnQuery: [{ "event": CommonTypesConversions_1.CommonTypesConversions.event.eventNameToEventQuery("ViewMainScreen") }]
                },
                response: {
                    chartData: Array.from([[0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0], [2, 2, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0], [1, 1, 1, 0, 0, 0, 0, 0], [1, 1, 1, 1, 0, 0, 0, 0], [2, 2, 1, 1, 0, 0, 0, 0], [2, 2, 1, 1, 0, 0, 0, 0], [2, 2, 1, 1, 0, 0, 0, 0], [2, 2, 1, 0, 0, 0, 0, 0], [2, 2, 1, 0, 0, 0, 0, 0], [3, 3, 0, 0, 0, 0, 0, 0], [2, 2, 1, 0, 0, 0, 0, 0], [1, 1, 1, 1, 0, 0, 0, 0], [1, 1, 1, 1, 1, 0, 0, 0], [1, 1, 1, 1, 1, 1, 0, 0], [5, 5, 1, 1, 1, 1, 1, 0], [5, 5, 1, 1, 1, 1, 1, 1], [5, 5, 1, 1, 1, 1, 1, 1]], v => Int32Array.from(v)),
                    periods: Uint32Array.from([1, 2, 3, 4, 5, 6, 7]),
                    intervalStartTimeSec: 1657152000
                },
                lineType: parameters.lineType,
                chartType: parameters.chartType,
                filterCohortDays: parameters.filterCohortDays || defaultStickinessChartSettingsJSONModelSerializedState.filterCohortDays,
                filterFrequency: parameters.filterFrequency || defaultStickinessChartSettingsJSONModelSerializedState.filterFrequency,
                shouldAddPeriod: parameters.shouldAddPeriod
            });
            lodash_1.default.each(options.series, (series, idx) => {
                if (idx === 1) {
                    series.color = "#d0d0d0";
                }
                else if (idx === 2) {
                    series.color = HighchartsThemeFacade_1.UsergeekHighchartsColors.black;
                }
            });
            return {
                options: options,
                chartStatus: chartStatus,
            };
        }
        return { options: {}, chartStatus: chartStatus };
    },
    getLifecycleOptions: (data, parameters, chartStatus) => {
        if (data && parameters.chartType && parameters.granularity) {
            const result = LifecycleHighchartsCalculations_1.LifecycleHighchartsCalculations.optionsFor(data, parameters, chartStatus);
            if (result.options.exporting) {
                result.options.exporting.enabled = false;
            }
            return result;
        }
        return { options: {}, chartStatus: chartStatus };
    }
};
